export const GET_DATA ="GET_DATA";
export const SET_DATA ="SET_DATA";
export const SET_SNACKBAR_DATA ="SET_SNACKBAR_DATA";
export const GET_SNACKBAR_DATA ="GET_SNACKBAR_DATA";
